<template>
  <div :class="[$style.customer, imgVisible ? $style.isImg : '']">
    <div :class="$style.header" @click="close">
      <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']"></i>
    </div>
    <img :src="imgUrl" alt="" v-if="imgVisible" @click="openLink">
    <iframe
      :class="$style.customerIframe"
      name="customerIframe"
      ref="customerIframe"
      :src="customerIframeUrl"
      v-if="customerIframeVisible"
    ></iframe>
  </div>
</template>

<script>
import { gameOpenDownloads } from '@/bridge/AppJsBridge';

export default {
  name: "",
  data() {
    return {
      imgVisible: false,
      imgUrl: '',
      nativeUrl: '',
      customerIframeUrl: '',
      customerIframeVisible: false
    };
  },
  mounted() {
    this.evoke53()
  },
  computed: {
  },
  methods: {
    close() {
      this.$emit('showSideWindow')
    },
    async evoke53() {
      this.customerIframeUrl = await this.$store.dispatch('global/getCustomerLink');
      this.customerIframeVisible = true;
    },
    openLink() {
      gameOpenDownloads({
        gameUrl: this.nativeUrl
      });
    }
  },
};
</script>

<style lang="scss" module>
.customer {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  font-size: 0;
  background-color: rgba(190, 190, 190, 1.0);
  &.isImg {
    width: 350px;
    left: 50%;
    top: 50%;
    height: 220px;
    transform: translate3d(-50%, -50%, 0);
    .header {
      .fanhui {
        right: 10px;
        top: 10px;
      }
    }
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    z-index: 10000000;
    .fanhui {
      font-size: 15px;
      position: absolute;
      color: #FFFFFF;
      background-color: #000000;
      right: 15px;
      top: 15px;
    }
  }
  .customerIframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
  }
  > img {
    width: 100%;
    height: 100%;
  }
}
</style>